import React, { FC } from 'react';

import { KnowledgeAreaLevel } from '../KnowledgeAreaLevel';
import { IKnowledgeAreaLevel } from '../KnowledgeAreaLevel/knowledge-area-level.interface';

interface IKnowledgeAreaLevelListProps {
  levels: IKnowledgeAreaLevel[];
  selectedLevelId: number;
  handleActiveLevel: (id: number, e: React.MouseEvent<HTMLElement>) => void;
  handleMenuOpen: (level: IKnowledgeAreaLevel) => void;
  handleEdit: () => void;
  handleRemove: () => void;
}

const KnowledgeAreaLevelList: FC<IKnowledgeAreaLevelListProps> = props => {
  const {
    levels,
    selectedLevelId,
    handleActiveLevel,
    handleMenuOpen,
    handleEdit,
    handleRemove,
  } = props;
  return (
    <ul>
      {levels.map((level, index) => (
        <li key={level.id}>
          <KnowledgeAreaLevel
            indexLevel={index}
            levelData={level}
            activeLevelId={selectedLevelId}
            handleActiveLevel={handleActiveLevel}
            handleMenuOpen={handleMenuOpen}
            handleEdit={handleEdit}
            handleRemove={handleRemove}
          />
        </li>
      ))}
    </ul>
  );
};

export { KnowledgeAreaLevelList };
